// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_8199","cover":"_6104","name":"_7624","desc":"_1786","percent":"_14785","price":"_12224","actions":"_11707","cancel":"_12848","confirm":"_7599"};